import React from "react";
  import axios from 'axios';
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { useNavigate } from "react-router-dom";

  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";
  import  NuEstado from "components/nubox/NuEstado";

  import { withRouterJim } from "router/withRouterJim";

  //---cutil
  import cUtilFecha from "helpers/cUtilFecha"
  
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import NuLoading from 'components/nubox/NuLoading';

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";




  /*const data = [
    { id_paciente: 1,  nombre: 'ALEX LIZARRAGA', }, 
  ];*/

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class TareaRevList extends React.Component {
    state = {

      modalActualizar: false,
      modalInsertar: false,
      isloaging:false,/* cargando ... */
      
      data: [],/* lista de datos */
      
      
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.modalRef = React.createRef();//create ref
      this.refNuConfirm = React.createRef();
    }
    //------------------
    
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});

      this.cargar_data();
      
      //this.cargar_cbo();
    }

    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    
    //====================================================== 
    //----cargamos los datos desde la base de datos
    cargar_data = () => {
      let user = this.props.store.user
      const materia = this.props.store.materia;

      let param = { 
        id_mate: materia.id_mate,
        id_peri: user.id_peri,
      }
      this.setState({isLoading: true});
      axios2.post("tarea_rev_list_get_list", param)
      .then(res => {
          this.setState({isLoading: false});

          if(res.data.length>0){ 
              this.setState({data: res.data});
          }else{
              NotificationManager.error("No existen datos");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }

    //-----------------------------------------------------------------
  nuevo = () => {
    this.modalRef.current.nuevo();
  }
  //-----------------------------------------------------------------
  
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar.');
    
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        
        let idd = item.id_acti;
        this.save(idd,'x');
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
  //--------------------------------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-------------
  onLinkClick = (e,item) => {
    e.preventDefault();
    this.props.navigate('/docente/e/'+ item.id_doc);
  };
  //-------------
  //=================== SAVE
  save =(idd, ope) =>{
      
  //let param = { idd:idd, ope:ope };
  let param = this.state.form
  param.idd = idd
  param.ope = ope
  console.log(param);

  axios2.post("taread_store", param)
  .then(res => {
      console.log(res.data);
      if(res.data.exito === 1){ 
          toast.success(res.data.mensaje);
          this.cargar_data();            
      }else{
          toast.error(res.data.mensaje);
      }
  }).catch(error => {
      alert("---- Existio un error ---");
      console.log(error);
  });
}
//-------------------------------------
    
    //-------------------------------------
    render() {
      let user = this.props.store.user
      let materia = this.props.store.materia
      return (
        <div>
          <ToastContainer />
          <NotificationContainer/>
          <div className="content">
            {
              //JSON.stringify(this.state.data)
            }
            {/*<!--- ------------------------------->*/}
            <div className="header">							
              <h4>LISTA DE TAREAS</h4>
                  <a href="http://localhost:8080/educo/public/tarea_revisar2_export2_csv/8" title="" className="btn btn-info btn-sm">
                      Exportar.
                  </a>

              <h3>{ materia.sigla } - <b>&nbsp;GRUPO:&nbsp;</b>{ materia.grupo}</h3>
              
            </div>

            
            <NuLoading text="Cargando...." show= { this.state.isloaging }/>

            <div className="table-responsive">
              <table className="tabla_azul table  table-bordered table-hover" width="100%" align="center">
                <thead>
                  <tr>
                    <th>Nro.</th>
                    <th>FECHA LIM.</th>
                    <th>TITULO</th>

                    <th>ARCHIVO</th>
                    <th>ACCION</th>
                  </tr>
                </thead>

                <tbody>          
                  {this.state.data.map((item,index) => (
                    <tr key={index}>
                      <td>{ item.id_tarea}</td>
                      <td>{ item.fecha_fin }</td>
                      <td>{ item.titulo}</td>
                      <td>{ item.filename}</td>
                      
                      <td>
                      <Link to={`/tarea_rev_list2/${item.id_tarea}`} 
                            title="" class="btn btn-primary btn-sm">
                        Revisar tarea
                      </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
                 
              </table>
            </div>

          

            
            {/*<!--- ----------------- form busqueda ------------------>*/}

            {/*<!-- -------------------------------------------------->*/}

          </div>
         
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(TareaRevList);

